import React from "react";
import "./Services.css";
import Header from "../../components/header/Header2";
import HeroSectionServices from "../../components/hero_section_services/HeroSectionServices";
import WebsiteDevelopmentService from "../../components/website_development_service/WebsiteDevelopmentService";
import TechStackWebDevelopment from "../../components/tech_stack_web_development/TechStackWebDevelopment";
import AndroidAppDevelopmentService from "../../components/android_app_development_service/AndroidAppDevelopmentService";
import TechStackAndroidDevelopment from "../../components/tech_stack_android_development/TechStackAndroidDevelopment";
import Footer from "../../components/footer/Footer";
import WhatsappCallBtn from "../../components/whatsapp_call_btn/WhatsappCallBtn";
import { Helmet } from "react-helmet";
export default function Services() {
  return (
    <>
      <Helmet>
        <title>
          Services | GlassHopeOne Technologies Pvt. Ltd. – Enterprise Software,
          SaaS & App Development
        </title>

        <meta
          name="description"
          content="GlassHopeOne Technologies Pvt. Ltd. offers enterprise software development, SaaS platform engineering, web application development, and mobile app solutions. We deliver scalable, secure, and future-ready technology services for businesses."
        />

        <meta
          name="keywords"
          content="enterprise software services, SaaS development services, web application development services, mobile app development services, custom software development, IT services company India, GlassHopeOne Technologies"
        />

        <meta name="author" content="GlassHopeOne Technologies Pvt. Ltd." />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />

        <link rel="canonical" href="https://www.glasshopeone.com/services" />
      </Helmet>

      <Header />
      <HeroSectionServices />
      <TechStackWebDevelopment />
      <WebsiteDevelopmentService />
      <TechStackAndroidDevelopment />
      <AndroidAppDevelopmentService />
      <WhatsappCallBtn />
      <Footer />
    </>
  );
}
